<template>
  <hic-list-page ref="listPage" title="手术" :entities="entities" :condition="condition" @load="page" :loading="meta.loading" header-height="3rem" keyword-placeholder="患者姓名">
    <template slot="search">
      <el-date-picker style="width: 270px" size="small" v-model="condition.date" type="date" placeholder="日期"></el-date-picker>
    </template>
    <el-table-column type="expand" class="custom">
      <template>
        <el-row style="padding: 0 1rem" type="flex" justify="space-between">
          <el-col>
            <el-link type="primary">手术知情书</el-link>
          </el-col>
          <el-col>
            <el-link type="primary">手术风险评估</el-link>
          </el-col>
          <el-col>
            <el-link type="primary">手术讨论记录</el-link>
          </el-col>
          <el-col>
            <el-link type="primary">术前小结</el-link>
          </el-col>
          <el-col>
            <el-link type="primary">术前主刀查房</el-link>
          </el-col>
          <el-col>
            <el-link type="primary">手术记录</el-link>
          </el-col>
          <el-col>
            <el-link type="primary">术后首程</el-link>
          </el-col>
          <el-col>
            <el-link type="primary">术后主刀查房</el-link>
          </el-col>
        </el-row>
      </template>
    </el-table-column>
    <el-table-column align="left" label="操作" width="100px">
      <template slot-scope="{ row }">
        <el-row type="flex" align="middle" justify="space-between">
          <el-button @click.native="meta.info = true" v-if="row.state == '待校对核' || row.state == '已排班' || row.state == '已完成'" icon="el-icon-search" size="mini" circle></el-button>
          <el-button @click.native="meta.editor = true" type="primary" v-if="row.state == '待提交' || row.state == '已拒绝'" size="mini" icon="el-icon-edit" circle></el-button>
          <el-popconfirm title="确定要撤回吗？">
            <el-button v-if="row.state == '待校对核'" slot="reference" icon="el-icon-refresh-left" size="mini" circle></el-button>
          </el-popconfirm>
          <el-button v-if="row.state == '已排班'" icon="el-icon-check" @click.native="meta.confirm = true" size="mini" circle></el-button>
          <el-button class="left-pad" v-if="row.state == '已拒绝' || row.state == '待提交'" type="danger" size="mini" icon="el-icon-delete" circle></el-button>
        </el-row>
      </template>
    </el-table-column>
    <el-table-column align="center" label="状态" prop="state"></el-table-column>
    <el-table-column align="center" label="手术编码" prop="code">
      <template slot-scope="{ row }">
        {{ row.code | dictText('ICD10') }}
      </template>
    </el-table-column>
    <el-table-column align="center" label="手术名称">
      <template slot-scope="{ row }">
        {{ row.name }}
      </template>
    </el-table-column>
    <el-table-column align="center" sortable="custom" label="手术级别" prop="grade">
      <template slot-scope="{ row }">
        {{ row.grade | dictText('SurgeryGrade') }}
      </template>
    </el-table-column>
    <el-table-column align="center" width="130px;" label="切口愈合等级" prop="healingCourse">
      <template slot-scope="{ row }">{{ row.healingCourse | dictText('HealingCourse') }}</template>
    </el-table-column>
    <el-table-column align="center" width="120px" label="患者姓名" prop="patientName"></el-table-column>
    <el-table-column width="120px" align="center" label="主刀医生" prop="doctorName">
      <template slot-scope="{ row }">{{ row.doctorName }}</template>
    </el-table-column>
    <el-table-column align="center" width="120px" label="麻醉方式" prop="anesthetistType">
      <template slot-scope="{ row }">{{ row.anesthetistType }}</template>
    </el-table-column>
    <el-table-column align="center" width="120px" label="手术室" prop="roomCode">
      <template slot-scope="{ row }">{{ row.roomCode | dictText('Dept') }}</template>
    </el-table-column>
    <el-table-column align="center" width="120px" label="预约时间" prop="planDate">
      <template slot-scope="{ row }">{{ row.planDate ? /\d{4}-\d{1,2}-\d{1,2}/g.exec(row.planDate)[0] : '' }}</template>
    </el-table-column>
    <el-table-column align="center" width="120px" label="申请人" prop="allergic"></el-table-column>
    <el-table-column align="center" width="120px" label="申请时间" prop="appDate">
      <template slot-scope="{ row }">{{ row.appDate ? /\d{4}-\d{1,2}-\d{1,2}/g.exec(row.appDate)[0] : '' }}</template>
    </el-table-column>
    <creator :entity="entity" title="手术申请" :visible.sync="meta.editor"></creator>
    <confirm :entity="entity" title="手术完成" :visible.sync="meta.confirm"></confirm>
    <info :entity="entity" title="手术详情" :visible.sync="meta.info"></info>
  </hic-list-page>
</template>

<script>
import api from './api';
import { mapGetters } from 'sw-hic';
export default {
  components: {
    creator: () => import('./creator'),
    confirm: () => import('./confirm'),
    info: () => import('./info'),
  },
  data() {
    return {
      entity: {},
      meta: {
        editor: false,
        loading: false,
        confirm: false,
        info: false,
      },
      condition: {
        date: null,
        keyword: null,
        sort: 'id',
        asc: false,
        pageSize: 20,
        pageIndexOnView: 1,
      },
      entities: {
        items: [],
      },
    };
  },
  computed: {
    ...mapGetters(['dict', 'getDict', 'dictEnum', 'Enum', 'permission', 'user']),
  },
  methods: {
    page() {
      this.meta.loading = true;
      api.Surgery.query(this.condition)
        .then(res => {})
        .catch(err => {
          this.$message.error(err || err.message);
        })
        .finally(f => {
          setTimeout(() => {
            this.meta.loading = false;
            this.entities.items = [
              {
                state: '待校对核',
                code: '88.5500',
                name: '胆囊切除',
                grade: '一级',
                healingCourse: '体表无切口',
                patientName: '老六',
                doctorName: '张医生',
                anesthetistType: '静吸麻醉',
                roomCode: '1号手术室',
                planDate: '2022-01-21 12:25:65',
                allergic: '张医生',
                appDate: '2021-02-68 14:58:14',
              },
              {
                state: '已排班',
                code: '88.5500',
                name: '胆囊切除',
                grade: '一级',
                healingCourse: '体表无切口',
                patientName: '老六',
                doctorName: '张医生',
                anesthetistType: '静吸麻醉',
                roomCode: '1号手术室',
                planDate: '2022-01-21 12:25:65',
                allergic: '张医生',
                appDate: '2021-02-68 14:58:14',
              },
              {
                state: '已完成',
                code: '88.5500',
                name: '胆囊切除',
                grade: '一级',
                healingCourse: '体表无切口',
                patientName: '老六',
                doctorName: '张医生',
                anesthetistType: '静吸麻醉',
                roomCode: '1号手术室',
                planDate: '2022-01-21 12:25:65',
                allergic: '张医生',
                appDate: '2021-02-68 14:58:14',
              },
              {
                state: '已拒绝',
                code: '88.5500',
                name: '胆囊切除',
                grade: '一级',
                healingCourse: '体表无切口',
                patientName: '老六',
                doctorName: '张医生',
                anesthetistType: '静吸麻醉',
                roomCode: '1号手术室',
                planDate: '2022-01-21 12:25:65',
                allergic: '张医生',
                appDate: '2021-02-68 14:58:14',
              },
              {
                state: '待提交',
                code: '88.5500',
                name: '胆囊切除',
                grade: '一级',
                healingCourse: '体表无切口',
                patientName: '老六',
                doctorName: '张医生',
                anesthetistType: '静吸麻醉',
                roomCode: '1号手术室',
                planDate: '2022-01-21 12:25:65',
                allergic: '张医生',
                appDate: '2021-02-68 14:58:14',
              },
            ];
          }, 1000);
        });
    },
  },
};
</script>

<style scoped>
/deep/ .el-table__row .el-table__expand-icon {
  /* //图标不旋转    */
  -webkit-transform: rotate(0deg);
  transform: rotate(0deg);
}

/deep/ .el-table__row .el-table__expand-icon,
/deep/ .el-table__row .el-icon-arrow-right:before {
  content: '\e7ad';
  font-size: 24px;
}

/deep/ .el-table__row .el-table__expand-icon > .el-icon {
  margin-left: -15px !important;
  margin-top: -12px !important;
}
</style>
